export default {
  system: {
    method: 'get',
    url: '/analysis/system'
  },
  driver: {
    method: 'post',
    url: '/analysis/driver'
  },
  quote: {
    method: 'get',
    url: '/analysis/quote'
  },
  quoteRequest: {
    method: 'get',
    url: '/analysis/quote-request'
  },
  cost: {
    method: 'post',
    url: '/analysis/cost'
  },
  finance: {
    method: 'get',
    url: '/analysis/finance'
  },
  getDriverTransportStatus: {
    method: 'get',
    url: '/dashbroad/driver-transport-status'
  }
}
